import { normalizeRouteKey, routeMatchesPage } from "../Routes/routeAccessPolicy.mjs";

export const matchLoadingCase = (caseData, { clientId, caseId }) => {
  if (!caseData || String(caseData.id) !== String(caseId)) return null;
  const clients = Array.isArray(caseData.for_client)
    ? caseData.for_client
    : [caseData.for_client || caseData.client_data];
  const client = clients.find((item) => item && String(item.id) === String(clientId));
  return client ? { ...caseData, for_client: client } : null;
};

export const getOpeningPageName = (pathname, pages) => {
  const page = Array.isArray(pages) && pages.find((item) => routeMatchesPage(pathname, item));
  if (page?.name) return page.name;
  const route = normalizeRouteKey(pathname);
  if (route === "treatment" || route === "bp-medicalmin") return "Treatment";
  return (
    (
      String(pathname || "")
        .split(/[?#]/, 1)[0]
        .split("/")
        .filter(Boolean)[0] || ""
    )
      .replace(/^bp-/, "")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .split(/[-_]/)
      .filter(Boolean)
      .map((word) => word[0].toUpperCase() + word.slice(1))
      .join(" ") || "Case"
  );
};

export const getOpeningPageIcon = (pathname, pages) => {
  const page = Array.isArray(pages) && pages.find((item) => routeMatchesPage(pathname, item));
  return page?.page_icon || null;
};
